<div class="cs-chat-icon">
    <img class="logo" src="{{ mediaServer }}/zeta/user/register/btn_cs-headphones.png" alt="" (click)="onCsChatIconClick()">
</div>